import styled, { css } from 'styled-components';

const defaultColor = '#6fdd0e';

export const Inside = styled.span`
	position: relative;
	display: inline-block;
	width: 100%;
	vertical-align: middle;
	background-color: #fff;
	line-height: 1;
	border-radius: 50%;
`;

export const Value = styled.span`
	font-size: 20px;
	${({ color }) => color && `color: ${color};`}
`;

export const Tooltip = styled.span`
	position: absolute;
	top: 50%;
	left: 100%;
	font-size: 13px;
	font-weight: 300;
	color: #303030;
	background-color: #e8e8e8;
	white-space: nowrap;
	padding: 0 10px;
	height: 24px;
	line-height: 24px;
	margin-top: -12px;
	margin-left: ${({ isRight }) => (isRight ? '24px' : '12px')};
	margin-right: ${({ isRight }) => (isRight ? '0' : 'auto')};
	visibility: hidden;
	opacity: 0;
	z-index: 9;
	transition: visibility 0s 0.3s ease, opacity 0.3s ease;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		width: 0;
		height: 0;
		right: 100%;
		border-top: 12px solid transparent;
		border-right: 12px solid #e8e8e8;
		border-bottom: 12px solid transparent;
		border-left: none;
		z-index: 10;
	}
`;

export const Corner = styled.span`
	position: absolute;
	top: 2px;
	right: -9px;
	width: 17px;
	height: 17px;
	box-sizing: border-box;
	border-top: ${({ borderColor }) => (borderColor ? `2px solid ${borderColor}` : `2px solid ${defaultColor}`)};
	border-right: ${({ borderColor }) => (borderColor ? `2px solid ${borderColor}` : `2px solid ${defaultColor}`)};
	background-color: #fff;
	transform: rotate(45deg);
	z-index: 1;
`;

const getType = (type, borderColor) => {
	switch (type) {
		case 'round-big':
			return css`
				width: 66px;
				height: 66px;
				text-align: center;
				line-height: 66px;
				border-radius: 50%;
				border: none;
				background-color: ${borderColor || defaultColor};
				box-sizing: border-box;

				${Value} {
					color: #fff;
					background-color: transparent;
					font-weight: bold;
					font-size: 32px;
				}

				${Inside} {
					background-color: transparent;
				}
			`;
		case 'round':
			return css`
				width: 32px;
				height: 32px;
				text-align: center;
				line-height: 32px;
				border-radius: 50%;
				border: none;
				background-color: ${borderColor || defaultColor};
				box-sizing: border-box;

				${Value} {
					color: #fff;
					background-color: transparent;
					font-weight: bold;
					font-size: 16px;
				}

				${Inside} {
					background-color: transparent;
				}
			`;
		case 'label':
			return css`
				height: 25px;
				border: 2px solid ${borderColor || defaultColor};
				border-right: none;
				box-sizing: border-box;
				line-height: 1;
				padding-left: 3px;
				position: relative;
			`;
		case 'label-transparent':
			return css`
				height: 25px;
				border: 2px solid ${borderColor || defaultColor};
				border-right: none;
				box-sizing: border-box;
				line-height: 1;
				padding-left: 3px;
				position: relative;
				background-color: transparent;

				&::before {
					background-color: transparent;
				}

				${Inside} {
					background-color: transparent;
				}
			`;
		case 'sector-bottom-left':
			return css`
				position: relative;
				width: 90px;
				height: 90px;
				background-color: ${borderColor || defaultColor};
				clip-path: circle(90px at 0 100%);

				${Value} {
					color: #fff;
					background-color: transparent;
					font-weight: 500;
					font-size: 32px;
				}

				${Inside} {
					position: absolute;
					bottom: 12px;
					left: 15px;
					width: auto;
					background-color: transparent;
				}
			`;
		case 'text':
			return css`
				width: auto;
				height: auto;
				line-height: 1;
			`;
		case 'inline':
			return css`
				span {
					padding: 2px 9px;
					color: #fff;
					font-weight: 500;
					font-size: 14px;
				}
			`;
		default:
			return null;
	}
};

export const Root = styled.div`
	background-color: #fff;
	font-size: 10px;
	color: #595651;
	font-weight: 300;
	display: inline-block;
	position: relative;
	flex-shrink: 0;
	${({ type, borderColor }) => type && getType(type, borderColor)}

	@media (min-width: 992px) {
		&:hover {
			${Tooltip} {
				visibility: visible;
				opacity: 1;
				transition: opacity 0.3s ease;
			}
		}
	}
`;
